"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLoyaltyTier = void 0;
const shared_1 = require("@getgreenline/shared");
const deleteLoyaltyTier = (companyId, loyaltyTierId, newLoyaltyTierId) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `/api/v1/companies/${companyId}/loyalties/${loyaltyTierId}`;
    if (newLoyaltyTierId) {
        url += `?newLoyaltyTierId=${newLoyaltyTierId}`;
    }
    return shared_1.axios.delete(url);
});
exports.deleteLoyaltyTier = deleteLoyaltyTier;
//# sourceMappingURL=loyaltyApi.js.map